<input
  TyaNumberVNInput
  [fullWidth]="true"
  nbInput
  [disabled]="disabled"
  [(ngModel)]="value"
  [status]="statusInput"
  (change)="change()"
/>
